import { IAppContext } from 'wisestep-api';

const adminCareerPage: IAppContext = {
  jobPageLogo: 'Logo',
  userId: 'admin',
  slug: 'jobs',
  generalSettings: {
    companySectionHeading: '',
    pageHeading: 'Work with us!',
    jobSectionHeading: 'Job Openings',
    companyName: 'Wisestep',
    companyNameSlug: 'jobs',
    about:
      "Wisestep is an AI and Automation driven ATS and Recruitment CRM Platform used by leading companies around the world. We aggregate all open jobs from our Customers' allowing interested candidates to apply for them.",
    logoURL: '/WisestepLogo.png',
    // logoURL: '/logo192.png',
    recruiterId: ['team.owner@wisestep.com'],
  },
  appearanceSettings: {
    bannerBackgroundColor:
      'linear-gradient(180deg, rgba(243, 250, 255, 0) 0%, #F3FAFF 46.88%, rgba(243, 250, 255, 0.844444) 100%);',
    headerTextColor: '#000000',
    pageHeadingColor: '#000000',
    bannerFontSize: '48px',
    showLogoText: true,
    bannerType: 'color',
    headerBackgroundColor:
      'linear-gradient(180deg, rgba(243, 250, 255, 0) 0%, #F3FAFF 46.88%, rgba(243, 250, 255, 0.844444) 100%);',
    headingFontSize: '32px',
    footerBackgroundColor: '#CAF0F8',
    footerFontSize: '16px',
    headingFontColor: '#3b4351',
    bannerURL: '',
    contentFontSize: '16px',
    mainBackgroundColor: '#ffffff',
    companySectionHeadingLocation: 'center',
    contentFontColor: '#77838f',
    jobSectionHeadingLocation: 'center',
    siteFont: 'Poppins',
    headerFontSize: '40px',
    isHeader: true,
    isBanner: false,
    isFooter: true,
    footerTextColor: '#000000',
    logoLocation: 'center',
    primaryColor: '#00B4D8',
    primaryTextColor: '#000000',
    secondaryColor: '#CAF0F8',
    secondaryTextColor: '#6E6E6E',
    faviconURL: '/favicon.ico',
  },
  jobsSettings: {
    jobTitle: true,
    companyName: true,
    location: true,
    compensation: true,
    description: true,
    skills: true,
    tags: false,
    postedDate: true,
    jobType: true,
  },
  candidatesSettings: {
    candidateName: 'mandatory',
    candidateEmail: 'mandatory',
    candidatePhone: 'mandatory',
    candidateAlternateEmail: 'hide',
    linkedInUrl: 'hide',
    messengerId: 'hide',
    certifications: 'hide',
    jobPreference: 'hide',
    commPreference: 'hide',
    location: 'mandatory',
    skills: 'hide',
    highestQualification: 'hide',
    institutionAttended: 'hide',
    currentJobTitle: 'hide',
    previousJobTitle: 'hide',
    currentEmployer: 'hide',
    previousEmployer: 'hide',
    totalExperience: 'hide',
    relevantExperience: 'hide',
    currentSalary: 'hide',
    expectedSalary: 'hide',
    otherBenefit: 'hide',
    expectedBenefits: 'hide',
    relocationPreference: 'hide',
    noticePeriod: 'hide',
    currentJobType: 'hide',
    otherInterviewStage: 'hide',
    reasonForJob: 'hide',
    recruiterAssessment: 'hide',
    workAuthorization: 'hide',
    currentJobTravel: 'hide',
    willingToTravel: 'hide',
    familyWillingToRelocate: 'hide',
    interviewingWithOthers: 'hide',
    resumeUpload: 'mandatory',
    otherDocuments: 'hide',
  },
  integrationSettings: {
    facebookShare: true,
    linkedInShare: true,
    emailShare: true,
  },
  isPreview: false,
  domain: '',
};

export default adminCareerPage;
